/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'heart': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M31.758 16.031c-5.074 0-10.121 2.004-13.969 6.031-7.695 8.051-7.715 20.973-.031 29.031l30.78 32.281c.747.79 2.161.79 2.907 0 10.27-10.746 20.512-21.504 30.78-32.25 7.696-8.05 7.696-20.98.001-29.03-7.695-8.052-20.273-8.052-27.97 0l-4.25 4.405-4.25-4.437c-4.147-4.356-9.284-6.05-14-6.031zm0 3.938c4 0 8.02 1.624 11.125 4.874l5.687 5.97c.747.788 2.16.788 2.907 0l5.656-5.938c6.21-6.5 16.008-6.5 22.219 0 6.21 6.5 6.21 17 0 23.5C69.57 58.609 59.79 68.859 50.008 79.094l-29.344-30.75c-6.207-6.508-6.211-17 0-23.5 3.105-3.25 7.094-4.875 11.094-4.875z"/>'
  }
})
